import { render, staticRenderFns } from "./PlacementTest.vue?vue&type=template&id=2993bd18&scoped=true"
import script from "./PlacementTest.vue?vue&type=script&lang=js"
export * from "./PlacementTest.vue?vue&type=script&lang=js"
import style0 from "./PlacementTest.vue?vue&type=style&index=0&id=2993bd18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993bd18",
  null
  
)

export default component.exports